import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'laas-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {

  @Input() inputType: string = 'text';
  @Input() parentFormGroup!: FormGroup;
  @Input() controlName!: string;
  @Input() toUppercase: boolean = false;
  @Input() invalidCondition!: boolean;

  constructor(private destroyRef: DestroyRef) { }

  /**
   * 開啟 toUppercase 時，表單值一有變動即轉為大寫，涵蓋人工輸入與程式帶值（如 Excel 匯入）。
   * 僅訂閱 valueChanges 而不處理原生 input 事件：輸入法組字期間表單值不會同步，
   * 若於 input 事件回寫表單值，會以舊值覆蓋組字中的內容，造成輸入卡住。
   * Uppercases on valueChanges only; writing back during native input events would
   * overwrite IME composition with the stale form value and block typing.
   */
  ngOnInit(): void {
    const control = this.parentFormGroup.get(this.controlName);
    control?.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value: unknown) => {
        if (!this.toUppercase || typeof value !== 'string') {
          return;
        }
        const upperValue = value.toUpperCase();
        // 值未改變時不回寫，避免重設輸入框導致游標跳到結尾 (skip no-op writes so the caret stays put)
        if (upperValue !== value) {
          control.setValue(upperValue, { emitEvent: false });
        }
      });
  }
}
